export const HOME = "/";
export const SIGNIN = "/auth/signin";
export const PROFILE = "/auth/profile";
export const LOCATION_BASED = "/location";
export const SAVED = "/saved";
export const SEARCH = "/search";
export const STOP = "/search/stop";
export const SERVICE = "/search/service";
export const SAMPLE_LOCATION = {
  woodlands: { lat: 1.43685, lon: 103.7842908 },
  waterway: { lat: 1.4061879, lon: 103.9027237 },
  whitesands: { lat: 1.371447, lon: 103.947521 },
  sengkangEDr: { lat: 1.387285, lon: 103.909069 },
};
